import { render, staticRenderFns } from "./AppealRecordTranscriptAppLeaveGrantedPg.vue?vue&type=template&id=4ceff2d8&scoped=true"
import script from "./AppealRecordTranscriptAppLeaveGrantedPg.vue?vue&type=script&lang=ts"
export * from "./AppealRecordTranscriptAppLeaveGrantedPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceff2d8",
  null
  
)

export default component.exports